// extracted by mini-css-extract-plugin
module.exports = {"image":"betone-module--image--TVOae","content":"betone-module--content--1QraP"};